import { forwardRef, useContext } from 'react';
import { DiskContext } from '../context';
import { CircularProgress, CircularProgressLabel } from '@mybridge/ui';
export const DiskDownloadProgress = forwardRef(({ ...props }, ref) => {
  const { download } = useContext(DiskContext);
  const { downloading, downloadedPercent } = download ?? {};
  return downloading ? (
    <CircularProgress value={downloadedPercent > 99 ? 0 : downloadedPercent}>
      <CircularProgressLabel>{downloadedPercent}%</CircularProgressLabel>
    </CircularProgress>
  ) : (
    <></>
  );
});
